import Shop from "./Shop";

const AiArt = () => <Shop category="AI Art" />;

export default AiArt;
